import { z } from "zod";
import type { Timestamp } from "firebase/firestore";

export const timestampSchema = z.custom<Timestamp>(
  (v): v is Timestamp =>
    v != null &&
    typeof v === "object" &&
    "toDate" in v &&
    typeof (v as { toDate: unknown }).toDate === "function",
  { message: "Oczekiwano Firestore Timestamp" },
);
